import React from 'react'

const ProgramBinder = () => {
  return (
    <section className="w-full">
      <div className="mb-4">
        <h2 className="text-2xl font-semibold text-slate-900">Program Binder</h2>
        <p className="text-sm text-slate-600">
          New Client Binder (Education)
        </p>
      </div>

      <div className="w-full overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <iframe
          title="New Client Binder 2018 Education"
          src="/assets/NewClientBinder_2018_Education.pdf"
          className="h-[calc(100vh-12rem)] min-h-[600px] w-full"
        />
      </div>
    </section>
  )
}

export default ProgramBinder
